<!--
  Generated template for the HistoryPage page.

  See http://ionicframework.com/docs/components/#navigation for more info on
  Ionic pages and navigation.
-->
<ion-header *ngIf="showHeader">

    <ion-toolbar>
        <ion-title>{{ 'Verlauf' | translate }}</ion-title>
    </ion-toolbar>

</ion-header>


<div class="main">
    <history #historyComponent [historyData]="patientDataProvider.activePatientData.history" (updateHistoryDesc)="updateHistoryDesc($event)"></history>
</div>
